import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
function HeroVisual() {
  return <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none" data-id="element-147">
      <div className="relative h-full rounded-2xl overflow-hidden bg-cream shadow-[0_30px_80px_-20px_rgba(45,74,62,0.45)]" data-id="element-148">
        <img src="https://cdn.magicpatterns.com/uploads/4uXSZcfaZLoWHJH1BmGxXK/CODIGO_HORMONAL_402B.jpg" alt="Dra. Elisabeth Mayo — Código Hormonal 40+" width={1080} height={1350} loading="eager" fetchPriority="high" decoding="async" className="w-full h-full object-cover" data-id="element-149" />
      </div>

      {/* Floating gold seal */}
      <div className="absolute -top-4 -right-4 md:-top-5 md:-right-5 w-20 h-20 md:w-24 md:h-24 rounded-full bg-gold flex items-center justify-center shadow-xl rotate-[-8deg]" aria-hidden="true" data-id="element-150">
        <div className="absolute inset-2 rounded-full border border-charcoal/20" data-id="element-151" />
        <div className="text-center text-charcoal leading-tight" data-id="element-152">
          <div className="font-serif text-[9px] md:text-[10px] tracking-[0.2em] uppercase font-bold" data-id="element-153">
            Edición
          </div>
          <div className="font-serif text-base md:text-lg font-bold italic" data-id="element-154">
            2026
          </div>
          <div className="font-serif text-[8px] md:text-[9px] tracking-[0.2em] uppercase" data-id="element-155">
            Limitada
          </div>
        </div>
      </div>
    </div>;
}
export function Hero() {
  return <section className="bg-cream py-12 md:py-20 lg:py-24" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-157">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-158">
          {/* Text column — rendered immediately for fast FCP */}
          <div data-id="element-159">
            <div className="flex items-center gap-3 mb-6" data-id="element-160">
              <span className="h-px w-8 bg-gold flex-shrink-0" aria-hidden="true" data-id="element-161" />
              <p className="text-[10px] md:text-xs font-bold tracking-[0.2em] text-gold uppercase leading-snug" data-id="element-162">
                Para mujeres que quieren volver a sentirse ellas mismas
              </p>
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-charcoal leading-[1.1] mb-8" data-id="element-163">
              Tu cuerpo no está roto{' '}
              <span className="italic text-forest" data-id="element-164">después de los 40.</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-charcoal/75 mb-6 leading-relaxed" data-id="element-165">
              Muchas mujeres empiezan a sentirse diferentes en esta etapa…{' '}
              <strong className="text-charcoal" data-id="element-166">
                más cansadas, menos ellas mismas,
              </strong>{' '}
              con cambios que nadie les explicó.
            </p>

            <p className="text-base md:text-lg lg:text-xl text-charcoal/75 mb-10 leading-relaxed" data-id="element-167">
              <strong className="text-charcoal" data-id="element-168">Código Hormonal 40+</strong> fue
              creado para ayudarte a comprender mejor lo que tu cuerpo necesita
              ahora.
            </p>

            <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full lg:w-auto bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-169">
              Ver la Presentación
              <ArrowRightIcon className="w-5 h-5" data-id="element-170" />
            </motion.a>

            <p className="text-charcoal/55 text-sm md:text-base mt-5 italic" data-id="element-171">
              Sin dietas extremas. Sin restricciones imposibles.
            </p>
          </div>

          {/* Visual column — Dra. Mayo portrait */}
          <HeroVisual data-id="element-172" />
        </div>
      </div>
    </section>;
}